import {
  CREATE_ORDER_FAILURE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  ORDER_DETAIL_FAILURE,
  ORDER_DETAIL_REQUEST,
  ORDER_DETAIL_SUCCESS,
  RESET_ALL_ACTIONS,
  RESET_CREATE_ORDER,
  UPDATE_ORDER_PAYMENT_FAILURE,
  UPDATE_ORDER_PAYMENT_REQUEST,
  UPDATE_ORDER_PAYMENT_SUCCESS,
} from "./ActionType";

const initialState = {
  orderDetailResult: null,
  loadingOrderDetail: false,
  errorOrderDetail: null,

  createOrderResult: null,
  loading: false,
  errorCreate: null,
  updateOrderPaymentResult: null,
  loadingUpdateOrderPayment: false,
  errorUpdateOrderPayment: null,
};

export const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        errorCreate: null,
      };
    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        createOrderResult: action.payload,
        errorCreate: null,
      };
    case CREATE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        errorCreate: action.payload,
      };
    case ORDER_DETAIL_REQUEST:
      return {
        ...state,
        loadingOrderDetail: true,
        errorOrderDetail: null,
      };

    case ORDER_DETAIL_SUCCESS:
      return {
        ...state,
        loadingOrderDetail: false,
        orderDetailResult: action.payload,
        errorOrderDetail: null,
      };

    case ORDER_DETAIL_FAILURE:
      return {
        ...state,
        loadingOrderDetail: false,
        errorOrderDetail: action.payload,
      };
    case RESET_CREATE_ORDER:
      return {
        ...state,
        createOrderResult: {},
        errorCreate: null,
      };
    case UPDATE_ORDER_PAYMENT_REQUEST:
      return {
        ...state,
        loadingUpdateOrderPayment: true,
        errorUpdateOrderPayment: null,
      };

    case UPDATE_ORDER_PAYMENT_SUCCESS:
      return {
        ...state,
        loadingUpdateOrderPayment: false,
        updateOrderPaymentResult: action.payload,
        errorUpdateOrderPayment: null,
      };

    case UPDATE_ORDER_PAYMENT_FAILURE:
      return {
        ...state,
        loadingUpdateOrderPayment: false,
        errorUpdateOrderPayment: action.payload,
      };
    case RESET_ALL_ACTIONS:
      return {
        ...state,
        createOrderResult: null,
        errorCreate: null,
        updateOrderPaymentResult: null,
        errorUpdateOrderPayment: null,
      };
    default:
      return state;
  }
};
